<template>
  <a-row :gutter="24" style="height: 100%">
    <a-col :md="24" :sm="24" style="height: 100%">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户地址')">
                <j-input :placeholder="$t('用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="meterId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :components="drag(columns)"
          @change="handleTableChange"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <span slot="action" slot-scope="text, record" class="action">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          </span>
        </a-table>
      </div>
    </a-col>
  </a-row>
</template>
    <script>
import { getAction, deleteAction, postAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import configService from '@/utils/service/config.service'
import { listSize } from '@/utils/util'
import Vue from 'vue'
export default {
  name: 'allIndex',
  mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
  components: {
    JInput,
  },
  data() {
    return {
      collapsed: false,
      //列设置
      settingColumns: [],
      data: [],
      visible: false,
      userPriceCode: [], // 价格编码
      description: 'meter_userinfo管理页面',
      url: {
        list: '/jeecg-charge/meter/meterUserinfo/list',
        userCaliberList: '/jeecg-charge/meter/meterCaliber/list', //表口径请求地址
        userTypeList: '/jeecg-charge/meter/meterUserType/list', //类别编码列表接口
        // list: "/jeecg-engineering/inspection/inspectionDevice/list",
        queryByDevice: '/jeecg-engineering/inspection/inspectionDevice/queryByDevice',
      },
      userCaliberList: [],
      userTypeList: [], //  类型编码
      queryParam: {
        importantFlag: 1,
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${configService.apiUrl}/${this.url.importExcelUrl}`
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('用户编号'),
          align: 'center',
          dataIndex: 'userId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('用户姓名'),
          align: 'center',
          dataIndex: 'userName',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('表类型'),
          align: 'center',
          dataIndex: 'meterTypeName',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('当前年度总用水量'),
          dataIndex: 'currentYearTotalWaterUse',
          align: 'center',
        },
        {
          title: this.$t('上年度总用水量'),
          dataIndex: 'lastYearTotalWaterUse',
          align: 'center',
        },
        {
          title: this.$t('同比变化量'),
          dataIndex: 'changeAmount',
          align: 'center',
        },
        {
          title: this.$t('同比变化百分比'),
          dataIndex: 'changePercentage',
          align: 'center',
        },
        {
          title: this.$t('异常标记'),
          dataIndex: 'abnormalFlag',
          align: 'center',
        },
      ]
    },
  },
  methods: {
    init(params) {
      this.queryUserCaliberList()
      this.queryUserTypeList()
      this.queryParam = Object.assign({},this.queryParam, params)
      this.loadData(1)
    },
    queryUserCaliberList() {
      //表口径请求
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      params.column = 'mtCaliber'
      params.order = 'asc'
      getAction(this.url.userCaliberList, params).then(res => {
        if (res.success) {
          this.userCaliberList = res.result.records
        }
      })
    },
    queryUserTypeList() {
      //类别编码
      let params = {}
      params.pageNo = 1
      params.pageSize = listSize
      getAction(this.url.userTypeList, params).then(res => {
        if (res.success) {
          this.userTypeList = res.result.records
        }
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      if (selectedRowKeys.length > 5) {
        this.$message.warning(this.$t('最多只能选择5个用户比对！'))
        return
      }
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
  },
}
</script>
    <style scoped lang="less">
.drawer-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.qrcodeInfo {
  color: #222;
  margin: 5px 0;
}
</style>
    <style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
</style>
    <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/* .new-table-card .ant-card-body .table-fixed {
    height: calc(100% - 207px);
  } */
</style>